<template>
  <div v-bind="$attrs">
    <v-switch
      ref="so-toggle"
      v-model="value"
      :label="label"
      :aria-label="ariaLabel"
      :name="name"
      :disabled="disabled"
      color="success"
      density="compact"
      hide-details="auto"
      inset
      inline
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      modelValue: {
        type: Boolean,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      ariaLabel: {
        type: String,
        default: undefined,
      },
      name: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(val: boolean) {
          this.$emit("update:modelValue", val)
        },
      },
    },
  })
</script>
